import { map } from "jquery";
import { React, useState, useEffect, useCallback, useContext } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useTable } from "react-table";
import OverflowToolTip from "../../shared/OverflowToolTip";
import './Profile.css'
// const ProfileHighlights = (ProfileHighlight) => { 
function ProfileHighlight(props) {
  //   props.Profile?.map(profile =>{
  //     console.log(profile.value,"valueabc")

  //     })
  //   console.log(props.Profile ,"propsprofile");

  //   return(0);
  //   // console.log(ProfileHighlight,'propsProfileHighlight');
  // };
  // export default ProfileHighlight;
  let count = props.Profile.length;
  let start = count % 3;
  
  const highlights = props.Highlights


  return (
    <div className="lg:mt-4 px-4 w-[100%]">
      <div className="lg:bg-white rounded-[6px]" x-show="tab === 1">
        <div className="w-full lg:grid lg:grid-cols-5 rounded-[6px] shadow-[0_2px_6px_0_rgba(0,0,0,0.08)]">
          <div className="mt-3 lg:mt-0 rounded-lg lg:rounded lg:col-span-3 lg:border-r bg-white ">
            <div className="mx-5 py-4 "> 
              <p className="text-[14pt] leading-[19pt] lg:text-[17px] text-[#333333] font-semibold lg:leading-[22px]">
                Profile
              </p>
              <div className=" mt-2">
                {props.Profile.length === 0 ?
                  // console.log(props.Profile.length, "hai")
                  (
                    <div className="overflow-x-auto lg:overflow-x-hidden overflow-y-hidden lg:overflow-y-hidden">
                      <table className="h-[10rem] w-full bg-[#FFFFFF] ">
                        <center>
                          <div role="status" className="bg-white  h-[16rem]">
                            <svg
                              className="relative top-[6rem] inline mr-2 w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]"
                              viewBox="0 0 100 101"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor"
                              />
                              <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill"
                              />
                            </svg>
                          </div>
                        </center>
                      </table>
                    </div>
                  ) :
                  (
                    <div className="divide-y overflow-x-auto lg:overflow-x-hidden overflow-y-hidden lg:overflow-y-hidden">
                      <div className="  w-full bg-[#FFFFFF] ">
                                              
                        <div className="grid grid-cols-3 ">
                          {props.Profile?.map((profileData,i ) => {

                            return (
                              <div className={"pr-[1rem] "+(i<12 ? "border-b":'' ) }>

                                <div className=" leading-[21px] font-sans_book_body ">
                                {/* <OverflowToolTip component={
                                  <p className=" py-1 text-[11pt]   leading-[18pt] lg:text-[13px] text-[#333333]  cursor-auto"
                                    readOnly >
                                     {profileData.label} 
                                  </p>
                                  } /> */}
                                   <p className=" py-1 text-[11pt]   leading-[18pt] lg:text-[13px] text-[#333333]  cursor-auto"
                                    readOnly >
                                     {profileData.label} 
                                  </p>
                                  <p  className=" mb-2 text-[11pt] break-words leading-[18pt] lg:text-[13px] text-[#333333] cursor-pointer font-semibold "
                                    readOnly >

                                    {profileData.label == "Website" || profileData.label == "LinkedIn"?
                                     profileData.value ? 
                                     <a className="hover:text-[#333333]" href={profileData.value} target='_blank' >{ profileData.value }</a>: "--"
                                    :
                                    profileData.label=="Contact Name, Designation" ?
                                    profileData.value ? <p className="w-[96%]  break-words ">{ profileData.value }</p>:"--":
                                    profileData.label=="Email" ?
                                    profileData.value ? <p className="w-[96%]  break-words ">{ profileData.value }</p>:"--":
                                    profileData.value ? profileData.value : "--"
                                  }
                                  </p> 
                                  
                                </div>
                                
                            </div>
                            
                            
                            )
                          })}
                        </div>
                      
                       
                      </div>
                      
                    </div>
                  )
                }
              </div>
            </div>
          </div>
          {/* <!--first half end--> */}
          {highlights.length === 0 ?
            (
              <div className="overflow-x-auto lg:overflow-x-hidden overflow-y-hidden lg:overflow-y-hidden">
                <table className="h-[10rem] w-full bg-[#FFFFFF] ">
                  <center>
                    <div role="status" className="bg-white  h-[16rem]">
                      <svg
                        className="relative top-[6rem] inline mr-2 w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                    </div>
                  </center>
                </table>
              </div>
            )
            :
            (<div className="w-full lg:col-span-2 bg-white mt-5 lg:mt-0  space-x-10 rounded-lg scrollbar">
              <div className="overflow-x-auto lg:grid lg:grid-rows-3 lg:grid-flow-col gap-3">
                <div className="row-span-2 px-5 lg:pl-8 pt-4 pb-2">
                  <div className="overflow-x-auto">
                    <p className="text-[14pt] leading-[19pt] text-[#333333] lg:text-[17px] font-semibold lg:leading-[22px]">
                      Highlights
                    </p>
                    {props.Highlights?.length <= 0 ? (
                      <table className="h-[4rem] w-full bg-[#FFFFFF] ">
                        <center>
                          <div role="status" className="bg-white  h-[6rem]">
                            <svg
                              className="relative top-[2rem] inline mr-2 w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]"
                              viewBox="0 0 100 101"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor"
                              />
                              <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill"
                              />
                            </svg>
                          </div>
                        </center>
                      </table>
                    ) : (
                      <div className=" w-full bg-[#FFFFFF] mt-1">
                        <div className="grid grid-cols-3 ">
                          {props.Highlights?.map((highlightsData,i) => {
                            return (
                              i<=2 &&
                              <div className="border-b pr-[1rem]">
                                <div className=" py-2 lg:leading-[21px] font-sans_book_body">
                                  
                                  <p
                                    className=" text-[11pt]  leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto"
                                    readOnly
                                  >
                                    {highlightsData.label}
                                  </p>

                                  <p
                                    className="text-[11pt]  leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold mb-1"
                                    readOnly
                                  >
                                    {highlightsData.value !="₹ 0 Cr" && highlightsData.value!="" ? highlightsData.value : "--"}
                                  </p>
                                </div>
                              </div>
                              
                  
                            )
                          })}
                        </div>
                        <div className="grid grid-cols-2 ">
                          {props.Highlights?.map((highlightsData,i) => {
                            return (
                              i>2 &&
                              <div className={i<5 ? 'border-b':''}>
                              <div className=" py-2 lg:leading-[21px] font-sans_book_body">
                                
                                <p
                                  className=" text-[11pt]  leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto"
                                  readOnly
                                >
                                  {highlightsData.label}
                                </p>

                                <p
                                  className="text-[11pt]  leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold mb-1"
                                  readOnly
                                >
                                  {highlightsData.value != 0 ?  highlightsData.value : "--"}
                                </p>
                              </div>
                              </div>
                  
                            )
                          })}
                        </div>

                      </div>
                    )}
                  </div>
                </div>
                <div className="row-span-1 border-t px-5 lg:pl-8 pt-2 mb-2">
                  <h3 className=" text-[14pt] leading-[19pt] text-[#333333] lg:text-[17px] font-semibold pt-2 lg:leading-[22px]">
                    Shareholding Pattern
                  </h3>
                  {props.ShareHolding?.length <= 0 ? (
                    <table className="h-[2rem] w-full bg-[#FFFFFF] ">
                      <center>
                        <div role="status" className="bg-white  h-[2rem]">
                          <svg
                            className="relative top-[2rem] inline mr-2 w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="currentColor"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentFill"
                            />
                          </svg>
                        </div>

                      </center>
                    </table>
                  ) : (
                    <div className="w-4/5">
                      <div className="grid grid-cols-2 gap-3 mt-1">
                        {props.ShareHolding?.map((shareholdingPatternData) => {
                          console.log(shareholdingPatternData, "bbbb")
                          return (
                            <div className="py-1  lg:leading-[21px] font-sans_book_body">
                              <p
                                className="text-[11pt]  leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto"
                                readOnly
                              >
                                {shareholdingPatternData.label}
                                {console.log(shareholdingPatternData.label, "mm")}
                              </p>

                              <p
                                className="text-[11pt]  leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold mb-1"
                                readOnly
                              >
                                {shareholdingPatternData.value && shareholdingPatternData.value !='0%'  ? shareholdingPatternData.value : "--"}
                              </p>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>)
          }

          {/* <!--end--> */}
        </div>
      </div>
    </div >

  );
};

export default ProfileHighlight;
